import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import Home from "./pages/home";
import Userlogin from "./pages/userlogin";
import Signup from "./pages/signup";
import Forgetpswd from "./pages/forgetpswd";
import Verifycode from "./pages/verifycode";
import Newpassword from "./pages/newpassword";
import Dashboard from "./dashboard/dashboard";
import Dashboardoutlet from "./dashboard/dashboardoutlet";
import Dashboardmain from "./dashboard/dashboardMain/dashboardmain";
import Setting from "./dashboard/settings/setting";
import Chatbot from "./dashboard/chatbot/chatbot";
import Aboutus from "./pages/aboutus";
import Features from "./pages/features";
import Pricing from "./pages/pricing";
import CaseManagement from "./dashboard/organizeDona/CaseManagment/caseManagement";
import ContractManagment from "./dashboard/organizeDona/ContactManagment/contractManagment";
import EvidenceManagment from "./dashboard/organizeDona/EvidenceManagement/evidenceManagment";
import ClientInfo from "./dashboard/organizeDona/ClientInfoManagement/clientInfo";
import ConfedentialitySecurity from "./dashboard/organizeDona/ConfedentialitySecurity/confedentialitySecurity";
import CaseTable from "./dashboard/organizeDona/CaseManagment/caseTable";
import CaseDetails from "./dashboard/organizeDona/CaseManagment/caseDetails";
import ContractTable from "./dashboard/organizeDona/ContactManagment/contractTable";
import ContractDetails from "./dashboard/organizeDona/ContactManagment/contractDetails";
import EvidenceTable from "./dashboard/organizeDona/EvidenceManagement/evidenceTable";
import EvidenceDetails from "./dashboard/organizeDona/EvidenceManagement/evidenceDetails";
import ClientTable from "./dashboard/organizeDona/ClientInfoManagement/clientTable";
import ClientDetails from "./dashboard/organizeDona/ClientInfoManagement/clientDetails";
import IncidentDetails from "./dashboard/organizeDona/IncidentDetails/incidentDetails";
import Incident from "./dashboard/organizeDona/IncidentDetails/incident";
import IncidentTable from "./dashboard/organizeDona/IncidentDetails/incidentTable";
import LegalProceedings from "./dashboard/organizeDona/LegalProceedings/legalProceedings";
import LegalTable from "./dashboard/organizeDona/LegalProceedings/legalTable";
import LegalDetails from "./dashboard/organizeDona/LegalProceedings/legalDetails";
import ProtectiveMeasures from "./dashboard/organizeDona/ProtectiveMeasures/protectiveMeasures";
import ProtectivemeasuresTable from "./dashboard/organizeDona/ProtectiveMeasures/protectivemeasuresTable";
import ProtectiveMeasuresDetails from "./dashboard/organizeDona/ProtectiveMeasures/protectiveMeasuresDetails";
import ConfedentialityTable from "./dashboard/organizeDona/ConfedentialitySecurity/confedentialityTable";
import ConfedentialityDetails from "./dashboard/organizeDona/ConfedentialitySecurity/confedentialityDetails";
import LegalSectors from "./dashboard/organizeDona/LegalSectors/legalSectors";
import LegalsectorTable from "./dashboard/organizeDona/LegalSectors/legalsectorTable";
import LegalSectorDetails from "./dashboard/organizeDona/LegalSectors/legalSectorDetails";

import Subscription from "./dashboard/subscription/subscription";

import AdminDashboard from "./adminDashboard/dashboard";
import AdminDashboardoutlet from "./adminDashboard/dashboardoutlet";
import AdminHome from "./adminDashboard/Home/home";
import AdminSetting from "./adminDashboard/settings/setting";
import Users from "./adminDashboard/Users/users";
import Files from "./adminDashboard/Files/files";
import Plans from "./adminDashboard/Plans/plans";
import UserDetails from "./adminDashboard/Users/userDetails";
import Chathistory from "./adminDashboard/Users/chathistory";
import Filesupload from "./adminDashboard/Users/filesupload";
import Protected from "./components/protectedRoute/protected";
import Blogs from "./pages/blogs";
import BlogDetail from "./pages/blogdetail";
import RatingandReviews from "./adminDashboard/RatingandReviews/ratingreviews";
import { useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { notificationsSocket } from "./socket";
import { io } from "socket.io-client";
import VoiceAssistant from "./dashboard/voiceAssistant/voiceAssistant";

import { showInfoToast, showSuccessToast } from "./utils/helpers";
import { ToastContainer } from "react-toastify";
import { getAllCasesStatistics } from "./APIs/caseApis";
import DonnaAIWebSocketTest from "./pages/test";

const AppLayout = () => {
  return (
    <>
      <ToastContainer />
      <RouterProvider router={appRouter} />
    </>
  );
};
const AppNew = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about-us",
    element: <Aboutus />,
  },
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/blogs",
    element: <Blogs />,
  },
  {
    path: "/blog-detail",
    element: <BlogDetail />,
  },
  {
    path: "/login",
    element: <Userlogin />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/reset-password",
    element: <Forgetpswd />,
  },
  {
    path: "/verify-code",
    element: <Verifycode />,
  },
  {
    path: "/new-password",
    element: <Newpassword />,
  },
  {
    path: "/",
    element: <Protected Component={Dashboard} />,
    // element: <Dashboard />,
    children: [
      {
        path: "/dashboard",
        element: <Dashboardoutlet />,
        children: [
          {
            path: "/dashboard",
            element: <Dashboardmain />,
          },
        ],
      },
      {
        path: "/chatbot/:id",
        element: <Chatbot />,
      },
      {
        path: "/chatbot",
        element: <Chatbot />,
      },
      {
        path: "/voice-assistant",
        element: <VoiceAssistant />,
      },
      {
        path: "/case",
        element: <CaseManagement />,
        children: [
          {
            path: "case-management",
            element: <CaseTable />,
          },
          {
            path: "case-details",
            element: <CaseDetails />,
          },
        ],
      },
      {
        path: "/contract",
        element: <ContractManagment />,
        children: [
          {
            path: "contract-management",
            element: <ContractTable />,
          },
          {
            path: "contract-details",
            element: <ContractDetails />,
          },
        ],
      },
      {
        path: "/evidence",
        element: <EvidenceManagment />,
        children: [
          {
            path: "evidence-management",
            element: <EvidenceTable />,
          },
          {
            path: "evidence-details",
            element: <EvidenceDetails />,
          },
        ],
      },
      {
        path: "/client",
        element: <ClientInfo />,
        children: [
          {
            path: "client-information",
            element: <ClientTable />,
          },
          {
            path: "client-details",
            element: <ClientDetails />,
          },
        ],
      },
      {
        path: "/incident",
        element: <Incident />,
        children: [
          {
            path: "incident-information",
            element: <IncidentTable />,
          },
          {
            path: "incident-details",
            element: <IncidentDetails />,
          },
        ],
      },
      {
        path: "/legal",
        element: <LegalProceedings />,
        children: [
          {
            path: "legal-proceedings-information",
            element: <LegalTable />,
          },
          {
            path: "legal-proceedings-details",
            element: <LegalDetails />,
          },
        ],
      },
      {
        path: "/measures",
        element: <ProtectiveMeasures />,
        children: [
          {
            path: "measures-information",
            element: <ProtectivemeasuresTable />,
          },
          {
            path: "measures-details",
            element: <ProtectiveMeasuresDetails />,
          },
        ],
      },
      {
        path: "/confedentiality-and-security",
        element: <ConfedentialitySecurity />,
        children: [
          {
            path: "information",
            element: <ConfedentialityTable />,
          },
          {
            path: "details",
            element: <ConfedentialityDetails />,
          },
        ],
      },
      {
        path: "/legal-sectors",
        element: <LegalSectors />,
        children: [
          {
            path: "information",
            element: <LegalsectorTable />,
          },
          {
            path: "details",
            element: <LegalSectorDetails />,
          },
        ],
      },
      {
        path: "/subscription",
        element: <Subscription />,
      },
      {
        path: "/settings",
        element: <Setting />,
      },
    ],
  },
  {
    // Wrapping Admin Dashboard and all its children inside Protected
    path: "/",
    element: <Protected Component={AdminDashboard} adminOnly={true} />,
    children: [
      {
        path: "/admin-dashboard",
        element: <AdminDashboardoutlet />,
        children: [
          {
            path: "/admin-dashboard",
            element: <AdminHome />,
          },
        ],
      },
      // {
      //   path: "/test",
      //   element: <DonnaAIWebSocketTest />,
      // },
      {
        path: "/users",
        element: <Protected Component={Users} adminOnly={true} />,
      },
      {
        path: "/user-details",
        element: <Protected Component={UserDetails} adminOnly={true} />,
        children: [
          {
            path: "chat-history",
            element: <Protected Component={Chathistory} adminOnly={true} />,
          },
          {
            path: "files-upload",
            element: <Protected Component={Filesupload} adminOnly={true} />,
          },
        ],
      },
      {
        path: "/files",
        element: <Protected Component={Files} adminOnly={true} />,
      },
      {
        path: "/plans",
        element: <Protected Component={Plans} adminOnly={true} />,
      },
      {
        path: "/rating-reviews",
        element: <Protected Component={RatingandReviews} adminOnly={true} />,
      },
      // {
      //   path: "/admin-settings",
      //   element: <AdminSetting />,
      // },
    ],
  },
]);

export default AppLayout;
